import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container purchasesummary-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"text-align":"center","color":"#333"}
}, " Purchase Summary ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin-top":"4px","line-height":"22px"} }, " We'll email you a confirmation of your policy. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "mobilecollpasetable"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  width: "48%",
  valign: "top",
  class: "success"
}, [
  /*#__PURE__*/_createElementVNode("table", {
    width: "100%",
    border: "0",
    cellspacing: "0",
    cellpadding: "0"
  }, [
    /*#__PURE__*/_createElementVNode("tbody", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          width: "20%",
          valign: "top"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "bigsuccess-checkmark" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
          /*#__PURE__*/_createElementVNode("strong", null, "Your Renters Insurance"),
          /*#__PURE__*/_createElementVNode("ul", null, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode("Property Damage & Personal Liability"),
              /*#__PURE__*/_createElementVNode("br")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode("Personal Property Coverage"),
              /*#__PURE__*/_createElementVNode("br")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("b", null, "Success! You're Covered."),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("span", { style: {"color":"#777","font-size":"13px","line-height":"18px"} }, [
            /*#__PURE__*/_createElementVNode("b", null, "Bank Statement Notice:"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" Transaction may appear as \"AGI* Renters/Condo Ins\".")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_12 = {
  valign: "top",
  class: "error"
}
const _hoisted_13 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", {
  width: "20%",
  valign: "top"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "bigerror-x" })
], -1)
const _hoisted_15 = { valign: "top" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, " Your Personal Property Accidental Damage Coverage Add-On ", -1)
const _hoisted_17 = { class: "try" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("em", null, "Things you can try...", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Visit "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.nssi.com/individual-quote",
    target: "_blank"
  }, "NSSI.com "),
  /*#__PURE__*/_createTextVNode(" to purchase ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.nssi.com/contact-us",
    target: "_blank"
  }, "Contact NSSI "),
  /*#__PURE__*/_createTextVNode(" for help or to report an issue ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createTextVNode("Failed! You're "),
  /*#__PURE__*/_createElementVNode("u", null, "NOT"),
  /*#__PURE__*/_createTextVNode(" covered for accidents!")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { style: {"line-height":"15px"} }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("table", {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "notice"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createTextVNode(" To manage your Renters Insurance policy, use "),
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://manage.myassurantpolicy.com/",
          target: "_blank"
        }, "MyAssurantPolicy"),
        /*#__PURE__*/_createTextVNode(". ")
      ])
    ])
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { style: {"text-align":"center","line-height":"22px"} }

import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import { EmailService } from "@/api/EmailService";
import ChangePaymentInfoModal from "@/views/modals/context/ChangePaymentInfoModal.vue";
import Modals from "@/utils/Modals";
// import ChangePaymentInfoModal from "@/views/modals/ChangePaymentInfoModal.vue";
import { PaymentMethod } from "@/models/PaymentMethod";
import { ReceiptService } from "@/api/ReceiptService";
//import { getReceipts } from "@/services/Functions";
import { onMounted, ref, computed, Ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteDoneFailedNssiApi',
  setup(__props) {

const loading: Ref<boolean> = ref(false);
const applicationPdfLink = ref("");
const orderLink = ref("");
const changePaymentInfo = ref(null);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const modals: Array<Modals> = [];

const getReceipt = async () => {
  //TODO get links and re usable function
  const response = await ReceiptService.getReceiptLink(quote);
  if (response.error === false) {
    applicationPdfLink.value = response.result.application_pdf_link;
    orderLink.value = response.result.order_link;
  }
};

//This function is not used
// function goToPage(command: string) {
//   quote.setQuoteStep(command);
// }

onMounted(async () => {
  if (!quote.folowUpMailSent) {
    await getReceipt();
    quote.nssiPassed = false;
    quote.folowUpMailSent = true;
    await EmailService.sendOrderReceipt(
      quote,
      user,
      applicationPdfLink.value,
      orderLink.value
    );
  }
});

const errorMsg = computed(() => {
  if (quote.personalInsurance.hasPaymentErrors) {
    return quote.nssiPolicyError;
  } else {
    return "Something went wrong. Please try again.";
  }
});
const checkDone = async () => {
  if (quote.assurantPassed && quote.nssiPassed) {
    quote.setQuoteStep("quote-done");
  }
  loading.value = false;
};
const getId = async () => {
  try {
    const cartId = await NssiData.toRemote(quote);
    return cartId;
  } catch (error) {
    console.log(error);
  }
};
const retryPersonal = async () => {
  loading.value = true;
  const result = await NssiData.issuePolicy(quote, user, getId);
  if (result.error) {
    quote.nssiPassed = false;
    quote.nssiPolicyError = result.message;
  } else {
    quote.nssiPolicyError = "";
    quote.nssiPassed = true;
    // quote.personalInsurance.orderId = result.policy.PolicyID;
    quote.personalInsurance.policyNumber = result.policy;
  }
  await checkDone();
};
function onPaymentMethodChanged(paymentMethod: PaymentMethod) {
  quote.checkout.paymentMethod.nameOnCard = paymentMethod.nameOnCard;
  quote.checkout.paymentMethod.cardNumber = paymentMethod.cardNumber;
  quote.checkout.paymentMethod.cvv = paymentMethod.cvv;
  quote.checkout.paymentMethod.expDateMonth = paymentMethod.expDateMonth;
  quote.checkout.paymentMethod.expDateYear = paymentMethod.expDateYear;
  retryPersonal();
}
function showChangePaymentInfoModal() {
  const modal = changePaymentInfo as any;
  modal.show();
}
function clearQuote() {
  quote.done = true;
}
const generateApplicationPdf = async () => {
  if (applicationPdfLink.value !== "") {
    window.open(applicationPdfLink.value);
  }
};
const generateOrderPdf = async () => {
  if (orderLink.value !== "") {
    window.open(orderLink.value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("table", _hoisted_10, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _hoisted_19,
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (retryPersonal()))
                            }, "Retry"),
                            _createTextVNode(" transaction ")
                          ]),
                          (_unref(quote).personalInsurance.hasPaymentErrors)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                _createTextVNode(" Try a "),
                                _createElementVNode("a", {
                                  class: "javascriptlink",
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showChangePaymentInfoModal()), ["prevent"]))
                                }, "different payment method, ")
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_21,
                          _hoisted_22
                        ])
                      ]),
                      _hoisted_23,
                      _hoisted_24,
                      _createElementVNode("small", _hoisted_25, _toDisplayString(errorMsg.value), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_26,
      _hoisted_27,
      _createElementVNode("table", {
        width: "100%",
        border: "0",
        cellspacing: "0",
        cellpadding: "0",
        class: "gold notice"
      }, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                target: "_blank",
                onClick: generateOrderPdf
              }, " View your order receipt (PDF) "),
              _createTextVNode("   |   "),
              _createElementVNode("button", {
                target: "_blank",
                onClick: generateApplicationPdf
              }, " View your application (PDF) ")
            ])
          ])
        ])
      ]),
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("p", _hoisted_30, [
        _createVNode(_component_router_link, {
          to: { name: 'home' },
          onClick: _cache[2] || (_cache[2] = ($event: any) => (clearQuote()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Return to homepage")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(ChangePaymentInfoModal, {
      ref_key: "changePaymentInfo",
      ref: changePaymentInfo,
      onPaymentChanged: onPaymentMethodChanged
    }, null, 512)
  ]))
}
}

})